import { useMemo, useState } from 'react';
import DOMPurify from 'dompurify';
import { FaCheck, FaTrashAlt, FaExclamationTriangle, FaInfoCircle, FaArchive } from 'react-icons/fa';

const BLOCK = 'LStudio__app_confirm';

/*
    🔥 EL CUERPO DEL CONFIRM — UNO SOLO PARA TODAS LAS IMPLEMENTACIONES

    Soporta el mismo contrato que tu SWAL2_ALERT_HELPER:

    requireText -> muestra un input y deshabilita el botón hasta que
                   el usuario escriba exactamente ese texto.
                   Es el equivalente de confirmHardDelete.
*/

export const CONFIRM_TONES = ['danger', 'warning', 'info', 'success'];

const TONE_ICON = {
    danger: FaTrashAlt,
    warning: FaExclamationTriangle,
    info: FaInfoCircle,
    success: FaCheck,
    archive: FaArchive,
};

export const ConfirmBody = ({
    tone = 'danger',
    icon = null,
    title = '¿Confirmás la acción?',
    text = '',
    html = '',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    requireText = null,
    requireLabel = 'Para confirmar, escribí exactamente:',
    onConfirm,
    onCancel,
}) => {

    const [useTyped, setTyped] = useState('');

    const Icon = TONE_ICON[icon ?? tone] ?? FaInfoCircle;

    const IS_LOCKED = !!requireText && useTyped.trim() !== String(requireText).trim();
    const SAFE_HTML = useMemo(() => DOMPurify.sanitize(String(html || '')), [html]);

    return (
        <div className={BLOCK} data-tone={tone} role="alertdialog" aria-modal="true">

            <div className={`${BLOCK}__icon`}>
                <Icon />
            </div>

            <h2 className={`${BLOCK}__title`}>{title}</h2>

            {text && <p className={`${BLOCK}__text`}>{text}</p>}

            {html && <div className={`${BLOCK}__text`} dangerouslySetInnerHTML={{ __html: SAFE_HTML }} />}

            {
                requireText && (
                    <div className={`${BLOCK}__require`}>

                        <label className={`${BLOCK}__require_label`} htmlFor="LStudio__confirm_require_input">
                            {requireLabel} <code className={`${BLOCK}__require_token`}>{requireText}</code>
                        </label>

                        <input id="LStudio__confirm_require_input" type="text" autoComplete="off"
                            className={`${BLOCK}__require_input`}
                            placeholder="Escribí acá para habilitar el botón"
                            value={useTyped} onChange={(event) => setTyped(event.target.value)} />

                    </div>
                )
            }

            <div className={`${BLOCK}__actions`}>

                <button type="button" className={`${BLOCK}__button ${BLOCK}__button--cancel`}
                    onClick={onCancel} >
                    {cancelText}
                </button>

                <button type="button" className={`${BLOCK}__button ${BLOCK}__button--confirm`}
                    onClick={onConfirm} disabled={IS_LOCKED} autoFocus={!requireText} >
                    {confirmText}
                </button>

            </div>

        </div>
    );
};
